import { EarlyPayPage } from '@repo/ccc-main-app-lib/src/pages/EarlyPayPage.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/user/$userId/early-pay')({
  component: UserEarlyPayPage,
})

function UserEarlyPayPage() {
  const { userId } = Route.useParams()

  return <EarlyPayPage userId={userId} />
}
